import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AuthScreen from "./screens/AuthScreen";
import AuthCallback from "./screens/AuthCallback";
import TodayScreen from "./screens/TodayScreen";
import AddMedicationScreen from "./screens/AddMedicationScreen";
import EditMedicationScreen from "./screens/EditMedicationScreen";
import MedsScreen from "./screens/MedsScreen";
import HistoryScreen from "./screens/HistoryScreen";
import SettingsScreen from "./screens/SettingsScreen";
import BottomNav from "./components/BottomNav";
import { Toaster } from "@/components/ui/sonner";

// Router component that handles session_id detection synchronously
function AppRouter({ isAuthenticated, setIsAuthenticated }) {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id - SYNCHRONOUS check before render
  // This prevents race conditions by processing new session_id FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback setIsAuthenticated={setIsAuthenticated} />;
  }

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/auth" element={<AuthScreen setIsAuthenticated={setIsAuthenticated} />} />
        <Route path="*" element={<Navigate to="/auth" replace />} />
      </Routes>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/today" element={<TodayScreen />} />
        <Route path="/add-medication" element={<AddMedicationScreen />} />
        <Route path="/edit-medication/:id" element={<EditMedicationScreen />} />
        <Route path="/meds" element={<MedsScreen />} />
        <Route path="/history" element={<HistoryScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="*" element={<Navigate to="/today" replace />} />
      </Routes>
      <BottomNav />
    </>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("medbuddy_token");
    setIsAuthenticated(!!token);
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="text-2xl font-medium text-gray-600">Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;